export default {
	navigation: {
		href: {
			map: 'zemljevid',
			illegal_waste_dumps_list: 'seznam-lokacij',
			user_management: 'upravljanje-uporabnikov',
			settings: 'nastavitve',
			history_change: 'zgodovina-sprememb',
			edit: 'uredi',
			create: 'ustvari',
		},
		label: {
			map: 'Zemljevid',
			illegal_waste_dumps_list: 'Seznam lokacij',
			user_management: 'Upravljanje uporabnikov',
			settings: 'Nastavitve',
			history_change: 'Zgodovina sprememb',
			edit: 'Uredi',
			create: 'Ustvari',
			delete_user_data: 'Izbris podatkov',
		},
	},
	illegal_waste_dumps: 'LNOP',
	id: 'Id',
	status: 'Status',
	insert_by: 'Prijavitelj',
	municipality: 'Občina',
	municipality_code: 'Šifra občine',
	cadastral_municipality: 'Katastrska občina',
	cadastral_municipality_code: 'Šifra katastrske občine',
	insert_at: 'Datum prijave',
	insert_at_from: 'Datum prijave od',
	insert_at_to: 'Datum prijave do',
	area: 'Površina',
	volume: 'Prostornina',
	waste_types: 'Vrsta in % odpadka',
	waste_dump_type_options: {
		NEW: 'Nova lokacija',
		CONFIRMED: 'Potrjena lokacija',
		SANITIZED: 'Sanirana lokacija',
		DRAFT: 'Draft',
	},
	waste_type: 'Tip odpadka',
	waste_fraction: 'Delež odpadka',
	waste_type_options: {
		ORGANIC_WASTE: 'Organic waste',
		CONSTRUCTION_WASTE: 'Construction waste',
		MUNICIPAL_WASTE: 'Municipal waste',
		BULKY_WASTE: 'Bulky waste',
		TIRES: 'Tires',
		MOTOR_VEHICLES: 'Motor vehicles',
		ASBESTOS_SHEETS: 'Asbestos sheets',
		HAZARDOUS_WASTE: 'Hazardous waste',
		CONTAINERS_WITH_HAZARDOUS_FLUIDS: 'Containers with hazardous fluids',
		I_DONT_KNOW: "I don't know",
		OTHER: 'Other',
	},
	ownership_type: 'Vrsta lastništva',
	actual_land_use: 'Dejanska raba zemljišča',
	dedicated_land_use: 'Namenska raba zemljišča',
	general_info: 'Splošno',
	location: 'Lokacija',
	legal_status: 'Pravni status',
	waste_dump_owner: 'Lastnik odpadka',
	land_owner: 'Lastnik zemljišča',
	responsible_person: 'Povzročitelj',
	images: 'Fotografije',
	update_at: 'Zadnje spremembe',
	lon: 'Lon (λ)',
	lat: 'Lat (φ)',
	remove_filters: 'Odstrani filtre',
	fullname: 'Ime in priimek',
	role: 'Vrsta pravic',
	access: 'Dostop do aplikacij',
	company: 'Podjetje / organizacija',
	active_date: 'Datum zadnje aktivnosti',
	user_roles: {
		admin: 'Skrbnik sistema',
		skilled_user: 'Napreden uporabnik',
		advanced_user: 'Strokovni sodelavec',
		user: 'Osnovni uporabnik',
	},
	delete_user_data: {
		delete_user_data: "Izbriši uporabnika",
		title: 'Izbris uporabnika',
		content: 'Ali ste prepričani da želite izbrisati vašega uporabnika? Tega dejanja ni mogoče razveljaviti.',
		cancel: "Prekliči",
		confirm_delete_user_data: 'Potrdi izbris podatkov',
		delete_success: "Uporabnik je bil uspešno izbrisan",
		delete_error: "Prišlo je do napake pri izbrisu uporabnika",
	},
	applications: {
		WEB: 'Spletna aplikacija',
		MOBILE: 'Mobilna aplikacija',
	},
	save: 'Shrani spremembe',
	cancel: 'Zavrzi spremembe',
	delete_location: "Izbriši lokacijo",
	delete_location_message: "Ali ste prepričani da želite izbrisati lokacijo? Tega dejanja ni mogoče razveljaviti.",
	delete: "Izbriši",
	delete_cancel: "Prekliči",
	delete_location_title: "Izbris lokcaije",
	delete_location_success: "Lokacija je bila uspešno izbrisana",
	delete_location_error: "Prišlo je do napake pri izbrisu lokacije",
	comment: 'Komentar',
	previous_edit_history: 'Prejšnja verzija',
	current_edit_history: 'Nova različica',
	update_by: 'Avtor spremembe',
	edited_at: 'Datum in ura spremembe',
	search_filter: {
		GENERAL: 'Iskanje po zemljevidu',
		PLOT_NUMBER: 'Iskanje po parcelah v katastru nepremičnin',
	},
	search: 'Išči',
	search_component: 'Iskalnik',
	map: 'Zemljevid',
	satellite: 'Posnetek',
	plots: 'Parcele',
	plot_numbers: 'Številke parcel',
	cadastral_municipalities: 'Katasterske občine',
	municipalities: 'Občine',
	size_of_waste_dump: 'Velikost lokacije',
	leave_page_title: 'Ste prepričani, da želite zapustiti stran?',
	leave_page_question: 'Trenutne spremembe ne bodo shranjene.',
	leave: 'Zapusti stran',
	Cancel: 'Ostani na strani',
	upload_image_too_large: 'Naložena slika je prevelika!',
	unsupported_file_type:
		'Naložena datoteka ni podprta! Naložite lahko le datoteko, ki ima končnico {{supportedFileTypes}}.',
	update_fail_title: 'Posodobitev ni uspela',
	update_fail_content: 'Posodobitev ni uspela. Prosimo poskusite ponovno.',
	update_success_title: 'Posodobitev je bila uspešna',
	update_success_content:
		'Posodobitev je bila uspešna. Najnovejši podatki so prikazani.',
	search_error_title: 'Iskanje ni bilo uspešno',
	search_error_content: 'Prišlo je do napake. Prosimo poskusite ponovno.',
	address_not_found_title: 'Naslov ni bilo mogoče najti',
	address_not_found_content:
		'Naslov ni bilo mogoče najti. Prosimo poskusite ponovno z drugim naslovom.',
	feature_info_not_found_title: 'Podatkov ni bilo mogoče pridobiti',
	feature_info_not_found_content:
		'Podatkov ni bilo mogoče pridobiti. Prosimo poskusite ponovno.',
	plot_not_found_title: 'Podatkov o zemljišču ni bilo mogoče pridobiti',
	plot_not_found_content:
		'Podatkov o zemljišču ni bilo mogoče pridobiti. Prosimo poskusite ponovno.',
	plot_error_title: 'Podatkov ni bilo mogoče pridobiti',
	plot_error_content:
		'Podatkov ni bilo mogoče pridobiti. Prosimo poskusite ponovno.',
	user_geolocation_error_title:
		'Zemljevid ni bilo mogoče centrirati na vašo lokacijo',
	user_geolocation_error_content:
		'Zemljevid ni bilo mogoče centrirati na vašo lokacijo. Omogočite dostop do geolokacije, če želite uporabljati to funkcionalnost.',
	plot_details: 'Podrobnosti o zemljišču',
	feedback: 'Povratne informacije',
	profile: 'Profil',
	first_name: 'Ime',
	last_name: 'Priimek',
	email: 'Email',
	back_to_start: 'Nazaj na začetek',
	close: 'Zapri',
	confirm: 'Potrdi',
	confirmation_needed: 'Potrebna je potrditev',
	user_role_change_confirm:
		'Uporabniku {{user}} boste dodeliti pravico {{role}}.',
	unauthorized: 'Do tega spletnega mesta žal nimate dostopa.',
	full_name: 'Uporabnik',
	last_login: 'Datum zadnje dejavnosti',
	last_login_from: 'Datum zadnje dejavnosti od',
	last_login_to: 'Datum zadnje dejavnosti do',
	create_new: 'Ustvari novo',
	parcel_number: 'Številka parcele',
	company_is_required_notification:
		'Prosimo izpolnite podatke o podjetju v vašem profilu!',
	create_new_illegal_waste_dump: 'Ustvari nov popis lokacije',
	use_selected_location: 'Uporabi izbrano lokacijo',
	save_draft: 'Shrani kot osnutek',
	no_information_for_plot:
		'Za izbrano parcelo ni bilo mogoče pridobiti vseh podatkov. Mankajoče podatke o parceli vnesite ročno.',
	update_warning_title: 'Delna posodobitev',
	update_warning_content:
		'Mogoča je bila le delna posodobitev. Prosimo poskusite ponovno.',
	update_location: 'Posodobite lokacijo',
	longitude: 'Lon (λ)',
	latitude: 'Lat (φ)',
	unauthorized_contact: 'Za več informacij se obrnite na administratorja',
};
